import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "../api.config";

export const socialMediaAuthApi = createApi({
  reducerPath: "socialMediaAuthApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["SocialConnections"],
  endpoints: (build) => ({
    // Get connection status for all platforms
    getConnections: build.query({
      query: () => ({ url: "/social-auth/connections", method: "GET" }),
      providesTags: ["SocialConnections"],
    }),

    // Get Meta (Facebook) OAuth URL
    getMetaAuthUrl: build.query({
      query: () => ({ url: "/social-auth/meta/auth-url", method: "GET" }),
    }),

    // Get Instagram OAuth URL (separate Instagram Login flow)
    getInstagramAuthUrl: build.query({
      query: () => ({ url: "/social-auth/instagram/auth-url", method: "GET" }),
    }),

    // Get LinkedIn OAuth URL
    getLinkedInAuthUrl: build.query({
      query: () => ({ url: "/social-auth/linkedin/auth-url", method: "GET" }),
    }),

    // Disconnect a platform
    disconnectPlatform: build.mutation({
      query: (platform) => ({ url: `/social-auth/disconnect/${platform}`, method: "DELETE" }),
      invalidatesTags: ["SocialConnections"],
    }),

    // Get Facebook pages
    getPages: build.query({
      query: () => ({ url: "/social-auth/pages", method: "GET" }),
    }),

    // Select a Facebook page
    selectPage: build.mutation({
      query: (body) => ({ url: "/social-auth/pages/select", method: "POST", body }),
      invalidatesTags: ["SocialConnections"],
    }),

    // Publish a post to connected platforms
    publishPost: build.mutation({
      query: (postId) => ({ url: `/social-auth/publish/${postId}`, method: "POST" }),
    }),
  }),
});

export const {
  useGetConnectionsQuery,
  useLazyGetMetaAuthUrlQuery,
  useLazyGetInstagramAuthUrlQuery,
  useLazyGetLinkedInAuthUrlQuery,
  useDisconnectPlatformMutation,
  useGetPagesQuery,
  useSelectPageMutation,
  usePublishPostMutation,
} = socialMediaAuthApi;
